import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import includes from "lodash/includes";
import isNil from "lodash/isNil";
import RoutesAndPagesMap from "./classes/routesAndPagesMap";
import { FULL_REDUX_ROUTING_PAGE_NAMESPACE } from "./constants";
export const routesAndPagesMap = new RoutesAndPagesMap();
export function registerRoutingKey(...args) {
    return createActionType(FULL_REDUX_ROUTING_PAGE_NAMESPACE, ...args);
}
export function registerRouting(routingActionType, pageObject) {
    var _a, _b;
    if (!routingActionType)
        return undefined;
    if (routesAndPagesMap.get(routingActionType)) {
        throw new Error(`Routing page '${routingActionType}' already registered`);
    }
    if (pageObject.self &&
        !isNil((_a = pageObject.self) === null || _a === void 0 ? void 0 : _a.hash) &&
        routesAndPagesMap.getByHash(pageObject.self.hash)) {
        throw new Error(`Hash '${pageObject.self.hash}' already registered`);
    }
    if (pageObject.self && !isNil((_b = pageObject.self) === null || _b === void 0 ? void 0 : _b.hash) && includes(pageObject.self.hash, "_")) {
        throw new Error(`Found underscore in hash ${pageObject.self.hash}. Shouldn't use it`);
    }
    if (!pageObject.self && routesAndPagesMap.getWithNoRoute()) {
        throw new Error("Empty routing (default page if no other was found) already exists");
    }
    routesAndPagesMap.add(routingActionType, pageObject);
    return routesAndPagesMap[routingActionType];
}
